<ngx-loading-bar color="#0272B6" height="3px" [includeSpinner]="false"></ngx-loading-bar>
<ngx-spinner bdColor="#FFF" size="medium" color="#9BA4AA" type="ball-pulse" [fullScreen]="true"></ngx-spinner>
<ui-view></ui-view>
